export class LigneFinancement {
         id: number;
         code: string;
         montant: number;
         libelle: string;
         typeMarche: string;
         dateDebut: String;
         dateFin: String;
       }
